<template>
  <b-modal
    v-model="modalShowfix"
    :title="$t('userlist')"
    size="sm"
    @hidden="clearModal"
  >
    <div
      v-if="employee"
      class="modal-content"
    >
      <div class="form-section">
        <h4 class="section-title">
          {{ $t('employeeinfo') }}
        </h4>

        <div class="employee-info">
          <div class="image-container">
            <img
              v-if="employee.profileImage"
              :src="`data:image/jpeg;base64,${employee.profileImage}`"
              alt="Employee Image"
              class="employee-image"
            >
            <span v-else>{{ $t('noimage') }}</span>
          </div>
        </div>

        <div class="info-item">
          <strong>{{ $t('workerid') }} : </strong> {{ employee.empid || '' }}
        </div>
        <div class="info-item">
          <strong>{{ $t('fullname') }} : </strong> {{ employee.username || '' }}
        </div>
        <div class="info-item">
          <strong>{{ $t('email') }} : </strong> {{ employee.email || '' }}
        </div>
        <div class="info-item">
          <strong>{{ $t('phone') }} : </strong> {{ employee.phone || '' }}
        </div>
        <div class="info-item">
          <strong>{{ $t('deptname') }} : </strong>
          <span>{{ employee.dept ? employee.dept.dept : '' }}</span>
        </div>

        <div class="info-item">
          <strong>{{ $t('jobtitle') }} : </strong> {{ employee.jobtitle ? employee.jobtitle.titleName : '' }}
        </div>
        <div class="info-item">
          <strong>{{ $t('role') }} : </strong>
          <span
            v-for="role in employee.roles"
            :key="role.id"
          >{{ role.name }}<br></span>
        </div>
        <div class="info-item">
          <strong>{{ $t('status') }} : </strong>
          <span :class="{'text-dark': !employee.isEnabled, 'text-danger': employee.isEnabled}">
            {{ employee.isEnabled ? $t('nonactive') : $t('active') }}
          </span>
        </div>
        <div class="info-item">
          <strong>{{ $t('signature') }} : </strong>
          <div class="image-container">
            <img
              v-if="employee.signature"
              :src="`data:image/png;base64,${employee.signature}`"
              alt="Signature"
              class="employee-signature"
            >
            <span v-else>{{ $t('noimage') }}</span>
          </div>
        </div>

      </div>

    </div>
    <div v-else>
      <p>{{ $t('nonuserdetails') }}</p>
    </div>

    <template #modal-footer>
      <b-button
        variant="dark"
        @click="modalShowfix = false"
      >
        {{ $t('close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    employee: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShowfix: this.show,
    }
  },
  watch: {
    show(newVal) {
      this.modalShowfix = newVal
    },
    modalShowfix(newVal) {
      if (!newVal) {
        this.clearModal()
      }
    },
  },
  methods: {
    clearModal() {
      this.$emit('close')
    },
  },
}
</script>

  <style scoped>
  .employee-image {
    width: 200px;
    height: 200px;
    border: 1px solid black; /* กรอบสีดำขนาด 1px */
    margin-bottom: 0.5rem;
  }

  .modal-content {
    padding: 1rem;
  }

  .form-section {
    margin-bottom: 1rem;
  }

  .section-title {
    text-align: center;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  .employee-info {
    display: flex;
    flex-direction: column;
    align-items: left;
    font-size: 16px;
  }

  .info-item {
    margin-bottom: 0.5rem;
  }

  .image-container {
    display: inline-block; /* Center image and text */
    text-align: center;
    margin-bottom: 3rem;
  }

  .text-danger {
    color: red;
  }
  .text-dark {
    color: black;
  }
  </style>
